import { createContext } from 'react';

/** Kept separate from the provider so the module only exports components for fast refresh. */
export const ThemeContext = createContext(null);

export const THEME_STORAGE_KEY = 'pickems.theme';
